import { ReactNode } from 'react';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { defaultTheme } from './ThemeContext';

interface Props {
  children: ReactNode;
}

const AppThemeProvider = ({ children }: Props) => {
  const muiTheme = createTheme(defaultTheme);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={muiTheme}> {children} </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default AppThemeProvider;
